<template>
  <div>
    <!-- 自动询货消息设置 -->
    <el-dialog :title="$t('message.autoAskPrice')" :close-on-click-modal="false" :visible.sync="dialogVisible"
      width="688px" center>
      <div class="content">
        <div class="item" v-for="(item, index) in remarkList" :key="index">
          <!-- 询货消息设置 -->
          <div class="label">
            <div class="name"> {{ item.type_name }}</div>
            <el-select v-model="item.delay_days" placeholder="消息延迟天数" size="small">
              <el-option label="立即发送" :value="0"></el-option>
              <el-option :label="`消息延迟${i}天`" :value="i" v-for="i in 10" :key="i">
              </el-option>
            </el-select>
            <span class="switch">
              是否发送消息 <el-switch v-model="item.is_enabled">
              </el-switch>
            </span>
          </div>
          <div class="val">
            <el-input v-model="item.message" onfocus="this.select()" type="textarea"
              placeholder="发送内容 交易号：{purchase_no}"></el-input>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <!-- 保存 -->
        <el-button type="primary" @click="save">{{
          $t("message.save")
        }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {

  data() {
    return {
      dialogVisible: false,
      remarkList: []
    };
  },
  methods: {
    // 保存
    save() {

      let datas = {
        configs: [],
      };
      this.remarkList.forEach(item => {
        datas.configs.push({
          type: item.type,
          is_enabled: item.is_enabled ? 1 : 0,
          delay_days: item.delay_days,
          message: item.message,
        })
      })

      this.$api.orderApi.purchaseMessageSet(datas).then((res) => {
        this.$message.success(res.msg);
        this.dialogVisible = false

      });
    },
  },
  watch: {
    dialogVisible(newVal, oldVal) {
      if (newVal) {
        this.$api.orderApi.purchaseMessageList().then((res) => {
          res.data.forEach(item => {
            item.is_enabled = item.is_enabled == 1 ? true : false
          })
          this.remarkList = res.data

        })
      }
    }
  }
};
</script>
<style lang='scss' scoped>
.content {
  margin: 0px 15px;


  .item {
    margin-bottom: 20px;

    .label {
      display: flex;
      justify-content: space-between;
      margin-bottom: 20px;

      .name {
        width: 150px;
      }

      &:last-child {
        margin-bottom: 0px;
      }
    }
  }
}

/deep/.el-textarea__inner {
  height: 100px
}
</style>